import { IMedia } from '@/interfaces';
import styles from '../../blog/blog.module.css';
import { useEffect, useState } from 'react';
import Image from 'next/image';
import { useGlobalContext } from '@/libs/context/GlobalContext';
type props = {
    mediaBannerData: IMedia[]
}
export function MediaCarousel({ mediaBannerData }: props) {
    const [active, setActive] = useState(0);
    const { props: { isMobileView } } = useGlobalContext()
    const [delay, setDelay] = useState(5000)
    useEffect(() => {
        const interval = setInterval(() => {
            setActive((prevIndex) =>
                prevIndex === mediaBannerData.length - 1 ? 0 : prevIndex + 1
            )
        }, delay);
        return () => clearInterval(interval);
    }, [active, mediaBannerData.length]);
    if (mediaBannerData.length == 0) return null;
    return <>
        <section id="demos" className={styles.media_banner}>
            <div className="row">
                <div className="large-12 columns">
                    <div className={`${styles.owl_carousel} ${styles.owl_theme} owl-carousel owl-theme`}>
                        {mediaBannerData && mediaBannerData.length > 0 && mediaBannerData.map((f, idx) =>
                            <div className={`item ${active === idx ? '' : 'dnone'}`} key={idx}>
                                <div className={styles.media_wrapper}>
                                    <div className={styles.banner_area}>
                                        {
                                            isMobileView ? <Image className="imgResponsive" src={f.featured_mobile_image} height={259} width={390} alt="media1" /> :
                                                <Image className="imgResponsive" src={f.featured_desktop_image} height={527} width={792} alt="media1" />
                                        }
                                        <div className={styles.title_overlay}>
                                            <span>{f.news_date}</span>
                                            <h4>{f.title}</h4>
                                        <Image src={f.media_logo || "/assets/images/tio1.jpg"} alt={f.slug} height={38} width={38} />
                                        </div>
                                    </div>
                                    <div className={`${styles.text_content} ${styles.none_col}`}>
                                        <p className={`text506E61 fontBold normallineheight lineHeight35 mb10 ${styles.small_heading}`}>{f.news_date}</p>
                                        <h3 className="normallineheight text333 mb10">
                                            {f.title}
                                        </h3>
                                        <p className={`normallineheight lineHeight25 mb10 ${styles.text_para}`}>
                                            {f.description}
                                        </p>
                                        <div className="mr20"><a href={f.news_link} target='_blank' className={`${styles.btn_squre} font14 textupper`}> Learn More</a></div>
                                    </div>
                                    <div className={`owl-dots ${styles.owl_dots}`}>
                                        {mediaBannerData && mediaBannerData.length > 1 && mediaBannerData.map((item, idx) => {
                                            return <button role="button" className={`${styles.owl_dot} ${active === idx ? styles.active : ''}`} key={idx} onClick={() => { setActive(idx), setDelay(500000) }}>
                                                <span></span>
                                            </button>
                                        })}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    </>
}